export const URL = {
  Root: '/',
  Manual: '/manual',
  Unit: '/unit',
  Vocabulary: '/vocabulary',
  Print: '/print',
  Manage: '/manage',
};
